export default __webpack_public_path__ + "static/media/GeraldKitchen.4c1a64c7.jpg";